(function ($, undefined) {
  var locale = $('html').attr('lang').substring(0, 2),
    trackingFormID = 'ae18411d-cf11-4983-8211-9af70e769071',
    subscriptionFormID = 'a83cfef2-0f68-4759-a0c8-3e5badde3c55';

  /*============================================
  Header JavaScript
  ==============================================*/
  $(function () {
    const $header = $('header.header'),
      $window = $(window),
      scrollTop = $window.scrollTop();

    if ($header.length) {
      $window.scroll(function () {
        const scroll = $window.scrollTop();
        scroll ? $header.addClass("header_fixed") : $header.removeClass("header_fixed");
      });

      if (scrollTop) {
        $header.addClass("header_fixed");
      }
    }
  });

  /*============================================
   Home page: /
   ==============================================*/
  $(function () {
    if (!$('body.home').length) {
      return false;
    }

    var homeSwiper = new Swiper(".home-review-swiper", {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".home-review-swiper-pagination",
        clickable: true,
      },
    });

    // show needed icon based on selected tab
    var $taxTabLink = $('.business-tabs__link'),
      $taxImg = $('.business-tax-img');

    $taxTabLink.on('click', function () {
      $taxImg.fadeOut(300);
      var $this = $(this),
        selectedTax = $this.data('tax-link');

      var $selectedTaxImg = $(`[data-tax="${selectedTax}"]`);
      $selectedTaxImg.fadeIn(300);
    });

    // Open video testimonials  on Home Page
    var $videoThumbnail = $('.slide__thumbnail');

    $videoThumbnail.click(function () {
      homeSwiper.autoplay.stop(); // stop slider

      var $this = $(this),
        $card = $this.parent($('.slide-video__player')),
        videoId = $card.data('video-id').trim();

      openSpotlightrVideoModal($this, videoId);
    });

    $('.video-on-demand-modal').click(function () {
      homeSwiper.autoplay.start();  // start slider, when close video modal
    });
  });

  /*============================================
  Demo on demand page: /demo/ondemand/
  ==============================================*/
  $(function () {
    if (!$('body.page-template-page-demo-on-demand').length) {
      return false;
    }

    /*============================================
    On page load check if tab is already chosen
    ==============================================*/
    var hash = window.location.hash.replace('#', ''),
      $tabs = $('.js-video-tab');

    if (window.location.hash) {
      $tabs.each(function () {
        var $this = $(this);

        if ($this.data('slug') === hash) {
          $this.tab('show');
        }
      });
    }

    $tabs.click(function () {
      var $this = $(this);

      // add active filter slug in the url
      window.location.hash = $this.data('slug');
    });

    /*============================================
    Set modal video iframe options
    ==============================================*/
    var $cardThumbnail = $('.demo-video-card__thumbnail');

    $cardThumbnail.click(function () {
      var $this = $(this),
        $card = $this.parent($('.demo-video-card')),
        videoId = $card.data('video-id').trim();

      openSpotlightrVideoModal($this, videoId);
    });

    /*============================================
    demo on demand gated modal window
    ==============================================*/
    var $gatedCard = $('.demo-video-card_hidden .demo-video-card__thumbnail');

    $gatedCard.click(function () {
      var $this = $(this),
        hsFormId = $this.data('hs-form-id'),
        $card = $this.parent($('.demo-video-card')),
        videoCategory = $card.data('category').trim() || 'No category found',
        videoId = $card.data('video-id').trim() || 'No video id found',
        videoTitle = $card.find('.demo-video-card-content__title').html().trim() || 'No title found';

      var videoData = {
        videoCategory,
        videoId,
        videoTitle,
        hsFormId
      };

      const checkEmailBoxInsteadOfVideoCookie = getCookie('demo_on_demand_submitted_video_form_message');

      if (checkEmailBoxInsteadOfVideoCookie === 'true') {
        showCheckYourEmailBlock();
      }

      const hasFormIdAndHaveVideoAccess = () => hsFormId && (checkEmailBoxInsteadOfVideoCookie !== 'true');

      if (hasFormIdAndHaveVideoAccess()) {
        createVideoHSForm(videoData);
      }
    });

    function showCheckYourEmailBlock() {
      const $gatedBlock = $('#gatedVideoOnDemandModal .gated-video-block'),
        $thankYouBlock = $('#gatedVideoOnDemandModal .thank-you-video-block'),
        $checkYourEmailBlock = $('#gatedVideoOnDemandModal .check-your-email-block');

      $gatedBlock.hide();
      $thankYouBlock.hide();
      $checkYourEmailBlock.removeClass('check-your-email-block_hidden').show();
    }

    function createVideoHSForm(videoData) {
      hbspt.forms.create({
        region: "na1",
        portalId: "7877093",
        formId: videoData.hsFormId,
        target: '.js-hs-form-demo-on-demand',
        onFormSubmit: function ($form) {
          formSubmit($form, videoData);
        },
        onFormReady: function ($form) {
          $form.find('input[name=mktg_inbound_device_information]')
            .val(getFingerprint())
            .change();
        }
      });
    }

    function formSubmit($form, videoData) {
      let currentParams = Object.fromEntries(new URLSearchParams(window.location.search).entries()),
        userEmail = $form.find('input[type="email"]').val(),
        fullAccessUrl = userEmail ? createFullAccessLinkWithGetParams(currentParams, userEmail) : '',
        videoId = videoData.videoId || '',
        videoCategory = videoData.videoCategory || '',
        videoTitle = videoData.videoTitle || '';

      $form.find('input[name="last_gated_content_full_access_url"]').val(fullAccessUrl).change();
      $form.find('input[name="video_id"]').val(videoId).change();
      $form.find('input[name="video_section_name"]').val(videoCategory).change();
      $form.find('input[name="video_name"]').val(videoTitle).change();

      // Show 'thank you' modal on submit
      var $gatedBlock = $('#gatedVideoOnDemandModal .gated-video-block'),
        $thankYouBlock = $('#gatedVideoOnDemandModal .thank-you-video-block');

      $gatedBlock.fadeOut('slow', function () {
        $thankYouBlock.fadeIn('slow');
      });

      // set private email access cookie (but dont use it yet)
      let oneMonthInSecond = 60 * 60 * 24 * 30;
      setCookie('demo_on_demand_email_access', userEmail, oneMonthInSecond);

      // Set submitted video form message cookie for 20 minutes (show this block instead showing form)
      const twentyMinutesInSeconds = 20 * 60;
      setCookie('demo_on_demand_submitted_video_form_message', 'true', twentyMinutesInSeconds);

      // Call LinkedIn tracking event
      window.lintrk('track', {conversion_id: 7666762});
    }

    // destroy HS form when modal close
    let $gatedModal = $('#gatedVideoOnDemandModal'),
      $HSFormBlock = $('.js-hs-form-demo-on-demand');

    $gatedModal.on("hidden.bs.modal", function () {
      $HSFormBlock.empty();
    });

    /*============================================
    send tracking data when see video
    ==============================================*/
    var $openCard = $('.demo-video-card:not(.demo-video-card_hidden) .demo-video-card__thumbnail');

    $openCard.click(function () {
      var $this = $(this),
        $card = $this.parent($('.demo-video-card')),
        videoCategory = $card.data('category').trim() || 'No category found',
        videoId = $card.data('video-id').trim() || 'No video id found',
        videoTitle = $card.find('.demo-video-card-content__title').html().trim() || 'No title found',
        email = getCookie('demo_on_demand_email_access');

      if (!email) {
        return;
      }

      var data = {
        "fields": [
          {
            "objectTypeId": "0-1",
            "name": "email",
            "value": email
          },
          {
            "objectTypeId": "0-1",
            "name": "video_name",
            "value": videoTitle
          },
          {
            "objectTypeId": "0-1",
            "name": "video_section_name",
            "value": videoCategory
          },
          {
            "objectTypeId": "0-1",
            "name": "video_id",
            "value": videoId
          }
        ],
        "legalConsentOptions": {
          "consent": { // Include this object when GDPR options are enabled
            "consentToProcess": true,
            "text": "I agree to allow Example Company to store and process my personal data.",
            "communications": [
              {
                "value": true,
                "subscriptionTypeId": 999,
                "text": "I agree to receive marketing communications from Example Company."
              }
            ]
          }
        },
        "context": {
          "pageName": document.title,
          "pageUri": document.URL
        }
      };

      // Docs: https://legacydocs.hubspot.com/docs/methods/forms/submit_form
      $.ajax({
        url: `https://api.hsforms.com/submissions/v3/integration/submit/7877093/${trackingFormID}`,
        type: "POST",
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: "json",
        success: function (data) {

        }
      });
    });
  });

  /*============================================
  Subscription form
  ==============================================*/
  $(function () {
    var $privacyText = $('.js-subscription-form-policy-text');

    window.addEventListener('message', function (event) {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit' && event.data.id === subscriptionFormID) {
        // hide privacy-policy text
        $privacyText.fadeOut('fast');

        // save email and redirect to demo page
        var businessEmail = event.data.data[0].value,
          demoPageUrl = '/demo/ondemand/';

        localStorage.setItem('businessEmail', businessEmail);
        window.location.href = locale + '/' + demoPageUrl;
      }
    });
  });

  /*============================================
  Enable parallax for products, use-cases and delivery page tmp
  ==============================================*/
  $(function () {
    if (!$('body.single-products').length && !$('body.page-template-page-delivery').length && !$('body.single-use-cases').length) {
      // exit
      return false;
    }

    const $benefits = $('.platforms-benefits'),
      lastBenefitHeight = $benefits.find('.platforms-benefits-item:last').height();

    // Adjust benefits-list-images margin (based on last block text size)
    if (lastBenefitHeight > 200) {
      $benefits.find(".benefits-list-images").css("margin-bottom", Math.floor(lastBenefitHeight / 2) + "px");
    }

    const showBenefitsImgById = (id) => {
      $benefits.find(`.benefits-list-images img:not([data-id="${id}"])`).removeClass("shown");
      $benefits.find(`.benefits-list-images img[data-id="${id}"]`).addClass("shown");
    }

    $(window).scroll(() => {
      if (!$benefits.isInViewport() || window.innerWidth < 992) return false;

      const $window = $(window),
        scrollTop = $window.scrollTop(),
        windowHeight = $window.height(),
        gridTop = windowHeight * .3,
        gridBottom = windowHeight * .6;

      $benefits.find('.platforms-benefits-item[data-id]').each(function () {
        const $this = $(this),
          $title = $this.find('.platforms-benefits-item__text-title'),
          elementId = $this.attr("data-id"),
          offsetTop = $title.offset().top,
          elementPosition = offsetTop - scrollTop,
          elementHeight = $title.height(),
          elementIsInMiddleOfScreen = elementPosition >= gridTop && (elementPosition + elementHeight) <= gridBottom;

        // If element is in Middle of the screen
        if ($this.isInViewport() && elementIsInMiddleOfScreen) {
          showBenefitsImgById(elementId);
        }
      });
    });
  });

  /*============================================
  Scroll to resources taxonomy block if there is query param
  ==============================================*/
  $(function () {
    // url should contain this query param
    if (!document.URL.includes('?scroll-to-category')) {
      return;
    }

    const $taxonomyBlock = $('.js-resources-taxonomy-block'),
      $adminBar = $('#wpadminbar');

    const OFFSET = $adminBar.length ? 22 : - 10,
      scrollTop = $taxonomyBlock.offset().top - $taxonomyBlock.height() - OFFSET;

    $('html, body').scrollTop(scrollTop);
  });

  /*============================================
  Helpers
  ==============================================*/
  function createFullAccessLinkWithGetParams(params, userEmail = '') {
    let searchUrl = window.location.origin + window.location.pathname;

    params.email_access = userEmail;

    const searchParams = new URLSearchParams(params);

    return searchUrl + '?' + searchParams.toString();
  }

  function setCookie(variable, value, expires_seconds) {
    var today = new Date(),
      domain = $(location).attr('hostname'),
      date = new Date(today.getTime() + 1000 * expires_seconds);

    document.cookie = variable + '=' + value + ';expires=' + date.toGMTString() + ';domain=.' + domain + ';path=/';
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return null;
  }

  function openSpotlightrVideoModal($this, videoId) {
    if (!videoId) {
      return;
    }

    var $spotlightrUrl = 'https://urbantz.cdn.spotlightr.com/watch',
      $modal = $('#showVideoOnDemandModal'),
      $iframe = $(".js-spotlightr-iframe", $modal);

    $iframe.attr('src', '');
    $iframe.attr('data-playerid', '');


    $iframe.attr('src', `${$spotlightrUrl}/${videoId}`);
    $iframe.attr('data-playerid', videoId);

    // close video on modal window close
    $modal.on("hidden.bs.modal", function () {
      $iframe.attr('src', function (i, val) {
        return val;
      });
    });
  }

  $.fn.isInViewport = function (offset) {
    let elementTop;

    if (offset) {
      elementTop = $(this).offset().top - offset;
    } else {
      elementTop = $(this).offset().top;
    }

    const elementBottom = elementTop + $(this).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  /*============================================
  Header advanced menu
  ==============================================*/
  $(function () {
    const $menuItemExpand = $(".menu-item .expand"),
      $advancedMenu = $(".advanced-menu");

    $menuItemExpand.click(function () {
      const $this = $(this);

      if ($this.attr("data-expand") === "advanced-menu") {
        $advancedMenu.slideToggle();
      } else {
        $this.parent().find(".sub-menu").slideToggle();
      }

      $(this).toggleClass("expanded");
    });
  });
})(jQuery);
